
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './RoomsBeds.css';
import {
  Button
} from 'react-bootstrap';
import cx from 'classnames';

// Redux Form
import { Field, reduxForm, formValueSelector, change, submit as submitForm } from 'redux-form';

// Redux
import { connect } from 'react-redux';

// Locale
import messages from '../../../../../locale/messages';

// Internal Component
import IncrementBtnCircle from '../../../../IncrementBtnCircle';

// Submit
import submit from '../../../SearchForm/submit';

class RoomsBeds extends Component {
  
  static propTypes = {
    className: PropTypes.any,
    handleTabToggle: PropTypes.any,
    isExpand: PropTypes.bool
  };

  static defaultProps = {
    isExpand: false,
    fieldsSettingsData: {
      bedrooms: [],
      bathrooms: [],
      beds: []
    },
  };

  constructor(props) {
    super(props);
  }

  renderIncrementButton = (field) => (
    <IncrementBtnCircle
      {...field}
    />
  );
  
  render() {
    const { className, handleTabToggle, isExpand } = this.props;
    const { fieldsSettingsData: { bedrooms, bathrooms, beds } } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={className}>
        <p className={cx(s.moreFilterTitle, s.space3, s.textBold)}>
          <FormattedMessage {...messages.accessPoints} />
        </p>
        <div className={cx(s.displayTable, s.space4)}>
          <div className={cx(s.displayTableCell, s.captionTitle, s.fullWidth, s.capitalizeText)}>
          <FormattedMessage {...messages.parkingCount} />
          </div>
          <div className={cx(s.displayTableCell, s.fullWidth)}>
            <Field
              name="parkingCount"
              type="text"
              component={this.renderIncrementButton}
              maxValue={10}
              minValue={0}
              incrementBy={1}
            />
          </div>
        </div>
        <div className={cx(s.displayTable, s.space4)}>
          <div className={cx(s.displayTableCell, s.captionTitle, s.fullWidth, s.capitalizeText)}>
          <FormattedMessage {...messages.truckDocks} />
          </div>
          <div className={cx(s.displayTableCell, s.fullWidth)}>
            <Field
              name="truckDocks"
              type="text"
              component={this.renderIncrementButton}
              maxValue={bedrooms[0].endValue}
              minValue={0}
              incrementBy={1}
            />
          </div>
        </div>
        <div className={cx(s.displayTable, s.space4)}>
          <div className={cx(s.displayTableCell, s.captionTitle, s.fullWidth, s.capitalizeText)}>
          <FormattedMessage {...messages.ramps} />
          </div>
          <div className={cx(s.displayTableCell, s.fullWidth)}>
            <Field
              name="ramps"
              type="text"
              component={this.renderIncrementButton}
              maxValue={10}
              minValue={0}
              incrementBy={1}
            />
          </div>
        </div>
        <div className={cx(s.displayTable, s.space4)}>
          <div className={cx(s.displayTableCell, s.captionTitle, s.fullWidth, s.capitalizeText)}>
          <FormattedMessage {...messages.gates} />
          </div>
          <div className={cx(s.displayTableCell, s.fullWidth)}>
            <Field
              name="gates"
              type="text"
              component={this.renderIncrementButton}
              maxValue={10}
              minValue={0}
              incrementBy={1}
            />
          </div>
        </div>
        <div className={cx(s.displayTable, s.space4)}>
          <div className={cx(s.displayTableCell, s.captionTitle, s.fullWidth, s.capitalizeText)}>
          <FormattedMessage {...messages.doors} />
          </div>
          <div className={cx(s.displayTableCell, s.fullWidth)}>
            <Field
              name="doors"
              type="text"
              component={this.renderIncrementButton}
              maxValue={10}
              minValue={0}
              incrementBy={1}
            />
          </div>
        </div>
      </div>
    );
  }
}

RoomsBeds = reduxForm({
  form: 'SearchForm', // a unique name for this form
  onSubmit: submit,
  destroyOnUnmount: false,
})(RoomsBeds);

// Decorate with connect to read form values
const selector = formValueSelector('SearchForm'); // <-- same as form name

const mapState = (state) => ({
  fieldsSettingsData: state.listingFields.data
});

const mapDispatch = {
  change,
  submitForm
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(RoomsBeds)));